import { observable, computed, action } from "mobx";

import { registrationStore, usersStore } from "../../index";
import { api } from "../../../services";

class Step_2 {
  @observable inProgress = false;

  constructor(registrationStore, usersStore) {
    this.registrationStore = registrationStore;
    this.usersStore = usersStore;
  }

  @action
  submit() {
    this.inProgress = true;
    let subscription = Object.assign({}, this.registrationStore.subscription);
    if (!subscription.status || subscription.status < 2) {
      this.inProgress = false;
      throw "status not valid";
    }

    Object.assign(subscription, { status: Math.max(2, subscription.status) });

    return api({ action: "update asset" }, registrationStore.session, registrationStore.assetId, { subscription })
      .then(updatedAsset => {
        this.registrationStore.setUserAsset(updatedAsset);
        this.usersStore.addOrModify(this.registrationStore.user);
        this.registrationStore.setSession(this.registrationStore.user._id);
        return {};
      })
      .catch(error => {
        return { error };
      })
      .then(({ error }) => {
        this.inProgress = false;
        if (error) {
          throw error;
        }
        return {};
      });
  }

  @computed
  get formValues() {
    return registrationStore.formValues.step_2;
  }

  @action
  setFormField(field, value) {
    this.registrationStore.setFormField("step_2", field, value);
  }

  @action
  setMyPosition() {
    this.registrationStore.setPosition(3);
  }

  @computed
  get session() {
    return this.registrationStore.session;
  }
}

export default new Step_2(registrationStore, usersStore);



// WEBPACK FOOTER //
// ./src/stores/registrationStore/steps/step_2.js